import { IncidentGeneralSectionWebComponent } from './component/IncidentGeneralSectionWebComponent';

export { IncidentGeneralSectionWebComponent };
